<template>
  <button
    :disabled="countChecked === 0 ? true : false"
    @click="handleDeletes"
    class="btn btn-danger btn-block"
  >
    <i class="fa fa-trash-alt"></i> Xóa
  </button>
</template>
<script>
export default {
  name: "delete-button",
  props: {
    countChecked: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleDeletes() {
      var self = this;
      if (this.countChecked == 0) {
        this.$swal({
          title: "Chưa chọn dòng nào",
          text: "Vui lòng chọn 1 dòng để thực hiện thao tác này !",
          type: "warning",
          confirmButtonText: "OK, Tôi hiểu rồi !"
        });
      } else {
        this.$swal({
          title: "Bạn có chắc thực hiện thao tác này?",
          text: "Bạn sẽ không thể hoàn nguyên điều này!!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "Không",
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            self.$emit("click");
          }
        });
      }
    }
  }
};
</script>
